import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const TYPE_CONFIG = {
  info: { icon: <InfoOutlinedIcon fontSize="small" />, color: 'primary.main' },
  success: { icon: <CheckCircleOutlineIcon fontSize="small" />, color: 'success.main' },
  warning: { icon: <WarningAmberIcon fontSize="small" />, color: 'warning.main' },
  error: { icon: <ErrorOutlineIcon fontSize="small" />, color: 'error.main' },
};

const READ_CONFIG = { icon: <CheckCircleOutlineIcon fontSize="small" />, color: 'text.disabled' };
const UNREAD_CONFIG = { icon: <InfoOutlinedIcon fontSize="small" />, color: 'primary.main' };

export function getNotificationConfig(notification) {
  return TYPE_CONFIG[notification.type] ?? (notification.read ? READ_CONFIG : UNREAD_CONFIG);
}

export function linkify(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(
    urlRegex,
    (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`,
  );
}
